import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50/50 to-white">
      {/* Header */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-gradient-to-br from-pink-100 to-rose-100 py-16"
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", delay: 0.2 }}
            className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg mb-6"
          >
            <ShieldCheck className="text-pink-500" size={32} />
          </motion.div>
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" 
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Privacy Policy
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-lg text-gray-600 italic"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Your privacy matters to us
          </motion.p>
        </div>
      </motion.div>

      {/* Content */}
      <motion.div 
        variants={staggerContainer}
        initial="hidden"
        animate="visible"
        className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
      >
        <motion.div variants={fadeInUp} className="prose prose-pink max-w-none">
          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Information We Collect</h2>
            <p className="text-gray-600 leading-relaxed">
              At The Pink Edit, we collect information you provide directly to us when you make a purchase, 
              create an account, sign up for our newsletter, or contact us. This includes your name, email 
              address, shipping address, and payment information. We use this information solely to process 
              your orders and provide you with the best shopping experience.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">How We Use Your Information</h2>
            <p className="text-gray-600 leading-relaxed">
              We use the information we collect to process transactions, send order confirmations and updates, 
              respond to your inquiries, and improve our services. We may also use your email to send you 
              promotional offers, but you can opt out at any time. We never sell or share your personal 
              information with third parties for marketing purposes.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Data Security</h2>
            <p className="text-gray-600 leading-relaxed">
              We implement industry-standard security measures to protect your personal information. 
              All transactions are processed through secure, encrypted connections. Your payment information 
              is never stored on our servers - it's handled directly by our trusted payment processors.
            </p>
          </motion.section>

          <motion.section 
            variants={fadeInUp}
            className="mb-8 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
            <p className="text-gray-600 leading-relaxed">
              If you have any questions about our Privacy Policy, please contact us at thepinkedit@yahoo.com. 
              We're committed to addressing your concerns and ensuring your privacy is protected.
            </p>
          </motion.section>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicyPage;
